
export default {
  height: {
    feet: ['4','5','6'],
    inches: ['0','1','2','3','4','5','6','7','8','9','10','11']
  },
  top_sizes: ['XS','S','M','L','XL','0X','1X'],
  dress_sizes: ['0','2','4','6','8','10','12','14','16','14W','16W'],
  jean_sizes: ['25','26','27','28','29','30','31','32','33','34','35','36'],
  pant_sizes: ['0','2','4','6','8','10','12','14','16','14W','16W'],
  bra_sizes: ['28','30','32','34','36','38'],
  cup_sizes: ['AA','A','B','C','D','DD','DDD','G','+'],
  body_shapes: [
    {
      key: 'hourglass',
      label: 'Hourglass',
      image: 'fit_shape_hourglass.png'
    },
    {
      key: 'inverted_triangle',
      label: 'Inverted Triangle',
      image: 'fit_shape_inverted_triangle.png'
    },
    {
      key: 'rectangle',
      label: 'Rectangle',
      image: 'fit_shape_rectangle.png'
    },
    {
      key: 'triangle',
      label: 'Triangle',
      image: 'fit_shape_triangle.png'
    },
    {
      key: 'oval',
      label: 'Oval',
      image: 'fit_shape_oval.png'
    }
  ]
}